import React from 'react';
import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Section from '@components/elements/section';
import RichText from '@components/elements/rich-text';
import { mixins, media } from '@styles';

const ItemProfile = props => {
  const { title, biography, callout, photos } = props;

  return (
    <Section padding="ph0">
      <StyledContainer>
        <StyledGrid>
          <StyledLeftBlock>
            {title && (
              <StyledTitle>
                <RichText richText={title} color="black" size={null} />
              </StyledTitle>
            )}
            <TextBox>
              {biography && (
                <StyledRichText>
                  <RichText
                    richText={biography}
                    color="softBlack"
                    className="profile-biography"></RichText>
                </StyledRichText>
              )}
              {callout && (
                <StyledRichText>
                  <RichText richText={callout} color="softBlack"></RichText>
                </StyledRichText>
              )}
            </TextBox>
          </StyledLeftBlock>
          <StyledRightBlock>
            <StyledImageWrapp>
              {photos && (
                <GatsbyImage image={getImage(photos[1])} className="member-photo" alt={photos[1]?.title} />
              )}
            </StyledImageWrapp>
          </StyledRightBlock>
        </StyledGrid>
        <MobileTextBox>
          {biography && (
            <StyledRichText>
              <RichText richText={biography} color="softBlack"></RichText>
            </StyledRichText>
          )}
          {callout && (
            <StyledRichText>
              <RichText richText={callout} color="softBlack"></RichText>
            </StyledRichText>
          )}
        </MobileTextBox>
      </StyledContainer>
    </Section>
  );
};

const StyledContainer = styled.div`
  padding-top: 102px;
  ${media.bigGiant`padding-top: 56px;`}
  ${media.giant`padding-top: 32px; padding-bottom: 64px;`}
  ${media.desktop`padding-top: 0px; padding-bottom: 32px;`}
`;

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 0 0px;
  min-height: 260px;
  ${media.desktop`grid-template-columns: repeat(8, 1fr);`};
`;

const StyledLeftBlock = styled.div`
  grid-column: 1 / span 8;
  padding-right: 32px;
  ${media.desktop`grid-column: 1 / span 5; padding-right: 16px; display: flex; align-items: center;`};
  ${media.thone`grid-column: 1 / span 4;`};
  ${media.phablet`
    grid-column: 1 / -1;
    grid-row: 2 / 3; 
    padding-bottom: 32px;
  `};
`;

const StyledRightBlock = styled.div`
  position: relative;
  grid-column: 9 / -1;
  ${media.desktop`grid-column: 6 / -1;`};
  ${media.thone`grid-column: 5 / -1;`};
  ${media.phablet`
    grid-column: 1 / -1;
    grid-row: 1 / 2; 
  `};

  .leadership-photo {
    width: 100%;
    height: auto;
  }
`;

const StyledImageWrapp = styled.div`
  overflow: hidden;
  position: absolute !important;
  width: 100%;
  height: 100%;
  top: -175px;
  height: 910px;
  ${media.bigGiant`top: -115px;`};
  ${media.giant`top: -90px;`};
  ${media.bigDesktop`top: -80px;`};
  ${media.desktop`top: -40px; position: relative !important; height: auto; margin-bottom: -40px;`};
  ${media.thone`top: -24px; margin-bottom: -8px;`};
  ${media.phablet`margin-bottom: 8px;`};
`;

const StyledTitle = styled.div`
  div {
    ${mixins.header50_small};
    ${media.giant`font-size: 24px;`};
  }
`;

const TextBox = styled.div`
  display: flex;
  padding-top: 64px;
  ${media.bigGiant`padding-top: 32px;`}
  ${media.giant`padding-top: 40px;`};
  ${media.desktop`display: none;`};

  .profile-biography {
    padding-right: 104px;
    ${media.bigGiant`padding-right: 72px;`};
  }
  div[class^='text__Content'] {
    ${mixins.text32_20_20_20_20};
  }
`;

const MobileTextBox = styled.div`
  display: none;
  ${media.desktop`display: grid; padding-top: 32px; grid-gap: 32px 32px; `}
  ${media.thone`padding-top: 0;`}
  div[class^='text__Content'] {
    ${mixins.text32_20_20_20_20};
  }
`;

const StyledRichText = styled.div`
  flex: 6;
`;

export default ItemProfile;
